let faqs = document.querySelectorAll('.btn-faq');

for (let i = 0; i < faqs.length; i++) {
  faqs[i].addEventListener('click', function () {
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      this.parentElement.classList.remove("active");
    } else {
      let active = document.querySelectorAll('.faq.active');
      for (let j = 0; j < active.length; j++) {
        active[j].classList.remove('active');
        active[j].querySelector('.faq-body').style.maxHeight = null;
      }
      this.parentElement.classList.add('active');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });
}

const btnLinks = document.querySelectorAll('.faq-list-tab-btn');

btnLinks.forEach((btnLink) => {
  btnLink.addEventListener('click', function (e) {
    const yOffset = -document.querySelector('header.header').offsetHeight;
    const element = document.getElementById(e.target.dataset.id);
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
});


// show active tabs on scroll
if(document.querySelectorAll('.faq-list-heading').length){
  window.addEventListener('scroll',function() {
    var windscroll = window.scrollY;
    if (windscroll >= 100) {
      document.querySelectorAll('.faq-list-heading').forEach(function(ele,i){
        if(ele.offsetTop <= windscroll + document.querySelector('header.header').offsetHeight){
          btnLinks.forEach((ele) => ele.classList.remove('active'));
          btnLinks[i].classList.add('active');
        }
      })
  
    } else {
      btnLinks.forEach((ele) => ele.classList.remove('active'));
      btnLinks[0].classList.add('active');
    }
  
  })
}

//calculate left most point of page
document.documentElement.style.setProperty('--diffWidth', `${(window.innerWidth - 1440) / 2}px`);